import { render, staticRenderFns } from "./update-reject.vue?vue&type=template&id=6c04c454&scoped=true&"
import script from "./update-reject.vue?vue&type=script&lang=js&"
export * from "./update-reject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c04c454",
  null
  
)

export default component.exports